export const cancels = {
    error: {
        fail: '불필요한 요청들을 취소하던 중 에러가 발생했습니다.',
    }
}